<template>
  <div
    class="summary"
    :class="{'summary--single': hasOnlyOneContact}"
  >

    <div class="summary__icon">
      <component :is="iconName"/>
    </div>

    <div class="summary__message">
      <span v-text="this.message"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectContactSummary',
  data() {
    return {
      singleContactMessageTemplate: `
        Confirme se este é seu CONTACT_NAME atual para
        enviarmos o código de verificação:
      `,
      multipleContactMessageTemplate: `
        Selecione seu CONTACT_NAME atual para
        enviarmos o código de verificação:
      `,
    };
  },

  props: [
    'isPhoneContactType',
    'contactList',
  ],

  computed: {
    iconName() {
      const nameSuffix = 'Svg';
      const iconName = this.isPhoneContactType
        ? `Cel${nameSuffix}`
        : `Mail${nameSuffix}`;

      return iconName;
    },

    message() {
      const message = this.getMessageByContactTypes(
        this.isPhoneContactType,
        this.hasOnlyOneContact,
      );
      return message;
    },

    hasOnlyOneContact() {
      return this.contactList.length <= 1;
    },
  },

  methods: {
    getMessageByContactTypes(isPhoneContactType, isSingleContact) {
      const template = isSingleContact
        ? this.singleContactMessageTemplate
        : this.multipleContactMessageTemplate;

      const message = isPhoneContactType
        ? template.replace('CONTACT_NAME', 'número')
        : template.replace('CONTACT_NAME', 'email');

      return message;
    },
  }
};
</script>

<style lang="scss">
.summary {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;

  &--single {
    padding-top: 60px;
  }

  &__icon {
    align-items: center;
    background-color: var(--color-primary-lighten-4);
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    height: 72px;
    justify-content: center;
    width: 72px;

    svg {
      height: 32px;

      path {
        fill: var(--color-primary);
      }
    }
  }

  &__message {
    line-height: 1.4;
    margin-top: 16px;
    max-width: 300px;
  }
}
</style>
